import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export function useHeaderMenu(headerNav) {
  const { t } = useTranslation()
  const [menuOpen, setMenuOpen] = useState(false)
  const navItems = Array.isArray(headerNav) ? headerNav : []
  const getLabel = (item) => (item.labelKey ? t(item.labelKey) : item.label || '')
  const closeMenu = () => setMenuOpen(false)
  const toggleMenu = () => setMenuOpen((open) => !open)

  return { menuOpen, navItems, getLabel, closeMenu, toggleMenu }
}
